import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1B3A32', // Deep Emerald Green
    },
    secondary: {
      main: '#F4B400', // Warm Yellow
    },
  },
});

export default theme;